<template>
  <!-- Non-live only. demo.pedalsure.com can serve any branch via the
       deploy-branch-to-demo pipeline, so this says which build is up on every
       page, including the funnel layouts that have no footer. Orange when it
       is not `stage`, so a feature branch is not mistaken for stage. -->
  <div
    v-if="isVisible"
    class="build-badge"
    :class="{ 'is-feature-branch': isFeatureBranch }"
    aria-hidden="true"
  >
    {{ label }}
  </div>
</template>

<script>
export default {
  computed: {
    isVisible() {
      return process.env.envType !== 'live'
    },
    isFeatureBranch() {
      const branch = process.env.appBranch
      return Boolean(branch) && branch !== 'stage'
    },
    label() {
      return [
        `v${process.env.appVersion}`,
        process.env.appCommit,
        process.env.appBranch,
        process.env.appCodeLabel,
      ]
        .filter(Boolean)
        .join(' · ')
    },
  },
}
</script>

<style lang="scss" scoped>
.build-badge {
  position: fixed;
  // Top edge, centred: at the bottom it sat on the funnel's fixed CTA
  // (Review my cover, Add bike); the live chat launcher is bottom-left.
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  max-width: calc(100vw - 16px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  z-index: 9999;
  // Never in the way of what is being tested: clicks pass straight through.
  pointer-events: none;
  padding: 0 6px;
  border-radius: 0 0 4px 4px;
  font-size: 10px;
  line-height: 1.5;
  font-family: monospace;
  color: #fff;
  background: rgba(48, 48, 48, 0.75);
  &.is-feature-branch {
    background: rgba(230, 110, 0, 0.92);
  }
}
</style>
